import { render } from "./privacy.vue?vue&type=template&id=8334ead8&scoped=true"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=8334ead8&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8334ead8"]])

export default __exports__